/**
 * authFlowContext — bridges auth screens and the root navigator.
 * Auth screens call enterApp() after a successful sign-in; the root navigator
 * flips phase 'auth' → 'app'. exitApp() does the reverse (logout).
 */
import React, { createContext, useContext } from 'react';

export type AuthPhase = 'booting' | 'auth' | 'app';

interface AuthFlow {
  phase: AuthPhase;
  enterApp: () => void;
  exitApp: () => void;
  refreshSession: () => void;
}

const AuthFlowContext = createContext<AuthFlow | null>(null);

export const AuthFlowProvider = AuthFlowContext.Provider;

export function useAuthFlow(): AuthFlow {
  const ctx = useContext(AuthFlowContext);
  if (!ctx) throw new Error('useAuthFlow must be used within AuthFlowProvider');
  return ctx;
}
